var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1617_85817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4999 5.57003V25.2C24.4999 26.7464 23.2463 28 21.6999 28H6.3C4.7536 28 3.5 26.7464 3.5 25.2V2.8C3.5 1.2536 4.7536 0 6.3 0H18.4357L24.4999 5.57003Z",
    fill: "url(#paint0_linear_1617_85817)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1617_85817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 5.57003H19.136C18.7494 5.57003 18.436 5.25663 18.436 4.87003V0L24.5002 5.57003Z",
    fill: "#ABEFC6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.4087 20.7998L10.5078 19.4453L9.71398 20.7998H8.49178L9.90928 18.5507L8.46028 16.3772H9.71398L10.6023 17.7128L11.3835 16.3772H12.6057L11.2008 18.6074L12.6624 20.7998H11.4087ZM14.2805 19.9682H15.6917V20.7998H13.2032V16.3772H14.2805V19.9682ZM17.8057 20.8439C17.4823 20.8439 17.1925 20.7914 16.9363 20.6864C16.6801 20.5814 16.4743 20.426 16.3189 20.2202C16.1677 20.0144 16.0879 19.7666 16.0795 19.4768H17.2261C17.2429 19.6406 17.2996 19.7666 17.3962 19.8548C17.4928 19.9388 17.6188 19.9808 17.7742 19.9808C17.9338 19.9808 18.0598 19.9451 18.1522 19.8737C18.2446 19.7981 18.2908 19.6952 18.2908 19.565C18.2908 19.4558 18.253 19.3655 18.1774 19.2941C18.106 19.2227 18.0157 19.1639 17.9065 19.1177C17.8015 19.0715 17.6503 19.019 17.4529 18.9602C17.1673 18.872 16.9342 18.7838 16.7536 18.6956C16.573 18.6074 16.4176 18.4772 16.2874 18.305C16.1572 18.1328 16.0921 17.9081 16.0921 17.6309C16.0921 17.2193 16.2412 16.898 16.5394 16.667C16.8376 16.4318 17.2261 16.3142 17.7049 16.3142C18.1921 16.3142 18.5848 16.4318 18.883 16.667C19.1812 16.898 19.3408 17.2214 19.3618 17.6372H18.1963C18.1879 17.4944 18.1354 17.3831 18.0388 17.3033C17.9422 17.2193 17.8183 17.1773 17.6671 17.1773C17.5369 17.1773 17.4319 17.213 17.3521 17.2844C17.2723 17.3516 17.2324 17.4503 17.2324 17.5805C17.2324 17.7233 17.2996 17.8346 17.434 17.9144C17.5684 17.9942 17.7784 18.0803 18.064 18.1727C18.3496 18.2693 18.5806 18.3617 18.757 18.4499C18.9376 18.5381 19.093 18.6662 19.2232 18.8342C19.3534 19.0022 19.4185 19.2185 19.4185 19.4831C19.4185 19.7351 19.3534 19.964 19.2232 20.1698C19.0972 20.3756 18.9124 20.5394 18.6688 20.6612C18.4252 20.783 18.1375 20.8439 17.8057 20.8439Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1617_85817",
    x: 16.336,
    y: -0.7,
    width: 8.86397,
    height: 8.37031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.7,
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1617_85817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1617_85817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1617_85817",
    x1: 35.35,
    y1: -16.45,
    x2: -8.05,
    y2: 40.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#75E0A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90788,
    stopColor: "#079455"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1617_85817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.593f5c7190956bfc0f29fe236198e718.svg";
export { ForwardRef as ReactComponent };